module.exports = __webpack_public_path__ + "static/media/empresa8.20af23b5.jpg";